import Vue from 'vue';
import Toast from './toast.vue'
 
const ToastBox = Vue.extend(Toast);
 
Toast.install = function (data) {
  let instance = new ToastBox({
    data
  }).$mount()
 
  document.body.appendChild(instance.$el)
 
  Vue.nextTick(() => {
    instance.show({
      msg: instance.msg,
      duration: instance.duration,
      customStyle: instance.customStyle
    })
  })
}
 
export default Toast


// WEBPACK FOOTER //
// ./src/pages/servitor/nySign/components/toast/index.js